import { AuthService } from './../../../../services/auth.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import Swal from 'sweetalert2';
import {User, UserParam} from '../../../../models/user.model';
import {IRole} from '../../../../models/role.model';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {UserService} from '../../../../services/user.service';
import {RoleService} from '../../../../services/role.service';
import {IWallet} from "../../../../models/wallet.model";
import {environment} from "../../../../environments/environment";
import {CommerciauxService} from "../../../../services/commerciaux.service";
import { Location } from '@angular/common';
import {Shop} from "../../../../models/shop.model";
import {ServiceService} from "../../../../services/service.service";
import {ShopService} from "../../../../services/shop.service";
import {ProductService} from "../../../../services/product.service";
import {WalletService} from "../../../../services/wallet.service";
@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss']
})
export class UserDetailsComponent implements OnInit {
  isSeller = false;
  isKahpoo = false;
  @ViewChild('closebutton') closebutton;
  @ViewChild('closebutton1') closebutton1;
  @ViewChild('closebutton2') closebutton2;
  // 🔥🔥👩
  shopUser: Shop[] = [];
  // @ts-ignore
  currentShop: IShop = [];

  // @ts-ignore
  currentUser: User = [];
  // @ts-ignore
  currentCommercial: User = [];
  // @ts-ignore
  currentRole: IRole = [];

  userParams: UserParam[] = [];
  params: any[] = [];

  /*
 -----------------------  select multiple          -----------------------------------------
  */
  dropdownListPerm = [];
  dropdownListRole = [];
  selectedItemsPerm = [];
  dropdownSettings = {};


  addRoleForm = this.fb.group({
    roles: new FormControl([], []),
  });
  showPerm = false;
  walletCostumer: IWallet;
  walletSeller: IWallet;
  // @ts-ignore
  currentWallet: IWallet = [];
  url_photo: string;
  selectedImage: string = '';

  form: FormGroup;
  onlyLettersAndNumbers = '[a-zA-Z0-9]+';
  paramAct = "Ajouter";

  constructor(private userService: UserService,
              private roleService: RoleService,
              private fb: FormBuilder,
              private router: Router,
              private serviceService: ServiceService,
              private shopService: ShopService,
              private walletService: WalletService,
              private productService: ProductService,
              private commerciauxService : CommerciauxService,
              private activatedRoute: ActivatedRoute, private authService: AuthService,private location: Location) { }

  ngOnInit(): void {
    this.authService.isAuthenticated().subscribe(isAuthenticated => {
      this.url_photo = environment.url_photo;
      this.loadUser();
      this.loadParam();
      this.dropdownSettings = {
        singleSelection: false,
        text: ' *** Selectionnez ***',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        enableSearchFilter: true,
        classes: 'myclass custom-class'
      };
    },error=>{
      this.router.navigate(['/login']);
    });
    this.form = this.fb.group({
      name: ['', [Validators.required]],
      value: ['',  [Validators.required, Validators.pattern('^[a-zA-Z0-9 ]+$')]]
    });

    //console.log(this.allParamsOfUser);
  }

  goBack(): void {
    this.location.back();
  }

  loadUser() {
    this.activatedRoute.params.subscribe(param => {
      this.loadPersonalInformation(param.id);
    });
  }

  private loadPersonalInformation(id: any) {
    this.userService.getidUser(id).subscribe(data => {
      // console.log("detailsssssssssssssss")
      // console.log(data);
      this.currentUser = data;
      if (this.currentUser.sellerAuthorization === 'vendeur') {
        this.isSeller = true;
      } else {
        this.isSeller = false;
      }

      this.getNbPurchaseByClient(this.currentUser.id);
      this.getNbPostBySeller(this.currentUser.id);

      if(this.currentUser.detailHowDidYouKnow){
        this.userService.getCommercialByCodeCommercial(this.currentUser.detailHowDidYouKnow).subscribe(rs=>{
          this.currentCommercial = rs;
          //console.log(this.currentCommercial)
        })
      }

      this.commerciauxService.getCommerciauxWithCode(data.commercialID).subscribe(rs=>{
        if(rs != null){
          this.currentUser.commercialID = rs.commercialID;
        }
      });
      // console.log(this.currentUser)
      this.isKahpoo = this.currentUser.kahpoo;
      this.loadUserParam();

      this.shopService.getShopByUser(this.currentUser.id).subscribe(rs => {
        // console.log('data here');
        this.shopUser = rs;
        // console.log(this.shopUser);

      });

      this.walletService.getUSerWallet(this.currentUser.id).subscribe(rs => {
        // @ts-ignore
        const wlt: IWallet[] = rs;
        wlt.forEach(value => {
          if (value.type === 'CUSTOMER') {
            this.walletCostumer = value;
          }
          if (value.type === 'SELLER') {
            this.walletSeller = value;
          }
        });
      });
    });
  }

  totalPost: number;
  getNbPostBySeller(id: number){
    this.userService.getNbPostPublished(id).subscribe(data => {
      //console.log(data);
      this.totalPost = data;
    }, error => {
      // console.log(error);
    })
  }

  totalPurchase: number;
  getNbPurchaseByClient(id: number){
    this.userService.getNbPurchase(id).subscribe(data => {
     // console.log(data);
      this.totalPurchase = data;
    }, error => {
      // console.log(error);
    })
  }

  private loadUserParam() {
    this.userService.getParamByUserId(this.currentUser.username).subscribe(rs => {
      this.userParams = rs;
    })
  }

  allParamsOfUser : UserParam[] = [];
  allParams: UserParam[];
  private loadParam() {
    this.userService.getAllUserParam().subscribe(rs => {
      this.params = rs;
    });
    this.userService.getAllParams().subscribe(data => {
      // console.log("------------------------");
      // console.log(data);
      // console.log(this.params);

      data.forEach(el => {
        this.params.forEach(p => {
          if(el.slug === p){
            this.allParamsOfUser.push(el);
          }
        })
      })
    });
  }

  onSubmit() {
    let p: UserParam = this.form.value;
    p.userID = this.currentUser.username;
    //console.log(this.form.value);
    this.userService.saveUserParam(this.form.value).subscribe(rs => {
         // console.log(rs);
          this.loadUser();
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Paramètre enregistré avec succès',
        showConfirmButton: false,
        timer: 1500
      });
    });
    this.form = this.fb.group({
      name: ['', [Validators.required]],
      value: ['', Validators.required]
    });
    this.paramAct = "Ajouter";
  }

  updateParam(p: any) {
    this.form = this.fb.group({
      id: [p.id, [Validators.required]],
      userID: [p.userID, [Validators.required]],
      name: [p.name, [Validators.required]],
      value: [p.value, Validators.required]
    });
    this.paramAct = "Modifier"
  }


  onViewWallet(wallet: IWallet) {
    this.currentWallet = wallet;
    // console.log("Détails wallet")
    // console.log(this.currentWallet)
  }

  private onViewShop(shop: any) {
    this.currentShop = shop;
    this.serviceService.getIdServiceByShop(this.currentShop.id).subscribe(dt => {
     // console.log(dt);
      // @ts-ignore
      this.currentShop.services = dt.content;
    });
    this.productService.getIdProductByShop(this.currentShop.id).subscribe((dt: any) => {
     // console.log(dt);
      this.currentShop.products = dt;
    });
   // console.log(this.currentShop);
  }

  displayImage(value: string) {
    this.selectedImage = value;
   // console.log(this.selectedImage);
  }
}
